module.exports = __webpack_public_path__ + "5cc1ffc251b8cca226760aada8b4b2a2.MP3";